<template>
  <div>
    <p
      v-if="isShortText"
      :class="$style.lineClamp"
      class="mb-0"
      v-text="text"
    />

    <p
      v-else
      class="mb-0"
      v-text="text"
    />

    <AppButton
      type="primary"
      text
      @click="isShortText = !isShortText"
    >
      <template #icon>
        <FaIcon :name="isShortText ? 'chevron-down' : 'chevron-up'" />
      </template>
      {{ isShortText ? 'mehr anzeigen' : 'weniger anzeigen' }}
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import AppButton from '@/application/components/ui/AppButton.vue';
import FaIcon from '@/application/components/ui/FaIcon.vue';

interface Props {
  text: string,
}
defineProps<Props>();

const isShortText = ref(true);
</script>

<style lang="scss" module>
  .lineClamp {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
</style>
